import { render, staticRenderFns } from "./InformationAboutContractor.vue?vue&type=template&id=9cedb2f0&"
import script from "./InformationAboutContractor.vue?vue&type=script&lang=js&"
export * from "./InformationAboutContractor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports